module.exports = __webpack_public_path__ + "img/p-taikang.f217bb37.png";